// ─────────────────────────────────────────────
// Shared ApexCharts theme for the dashboard.
//
// Every dashboard chart previously defined its own one-off `colors`
// array and axis/grid/tooltip style literals, which is why the
// dashboard used to show blue+cyan, purple+blue, a 10-color rainbow
// and plain ApexCharts defaults side by side. Chart files should pull
// `CHART_PALETTE` for their `colors:` array and splice these style
// fragments into their `options` object (at the same nesting ApexCharts
// expects — xaxis.labels.style, tooltip.style, etc.) instead of
// hand-writing font/color literals, so every chart on the dashboard
// reads as one visual system.
// ─────────────────────────────────────────────

// Brand-led categorical palette (teal primary, app secondary green, then
// a few well-separated hues) — used in order for categorical series,
// or picked by index for two-tone/semantic series.
export const CHART_PALETTE = [
  "#08757C", // brand teal
  "#8FC444", // brand secondary green
  "#4A90D9", // blue
  "#F5A623", // amber
  "#8E63C9", // purple
  "#546E7A", // slate
  "#E8635A", // coral
  "#2FBFAE", // teal-light
];

// Billable vs Non-Billable is the recurring two-series pairing across the
// dashboard's hours charts (Project-wise Hours, Test Type Analysis,
// Lab-wise Project Utilization) — a light tint of the same brand teal
// used for Billable, rather than an unrelated second hue, so the pair
// reads as "same measure, two states" instead of two different metrics.
export const HOURS_COLORS = [CHART_PALETTE[0], "#8FD3D6"];

export const CHART_FONT = "'Poppins', sans-serif";

export const axisLabelStyle = {
  fontSize: "12px",
  fontWeight: 600,
  colors: "#64748B", // slate-500
  fontFamily: CHART_FONT,
};

export const axisTitleStyle = {
  fontSize: "13px",
  fontWeight: 700,
  color: "#334155", // slate-700
  fontFamily: CHART_FONT,
};

export const gridBase = {
  borderColor: "#E2E8F0", // slate-200
  strokeDashArray: 0,
};

export const tooltipStyleBase = {
  fontSize: "12px",
  fontFamily: CHART_FONT,
};

// Box styling ApexCharts applies to the tooltip's outer element.
export const tooltipBoxStyle = {
  padding: "10px 14px",
  borderRadius: "8px",
  boxShadow: "0 8px 20px rgba(15, 23, 42, 0.12)",
};

// Data label text colors for bars/segments — white on dark fills,
// slate-900 on light fills.
export const dataLabelColors = ["#ffffff", "#1e293b"];

export const dataLabelStyle = {
  fontSize: "11px",
  fontWeight: 700,
  colors: dataLabelColors,
  fontFamily: CHART_FONT,
};

// Common `chart.*` chrome shared by every ApexCharts instance.
export const chartChrome = {
  fontFamily: CHART_FONT,
  background: "transparent",
};
